export const errorMessages = {
  basket: {
    limitedQuantity:
      "You have reached the maximum quantity available",
    outOfStock: "Out of stock. Please remove from your bag"
  },

  authentication: {
    incorrectEmailOrPassword:
      "Your email address or password are incorrect, please try again.",
    invalidEmail: "Please enter a valid email address",
    emptyFirstName: "First name is required",
    emptyLastName: "Last name is required",
    emptyEmail: "Email address is required",
    emptyPassword: "Password is required",
    invalidPassword:
      "Password must have minimum length of 8 characters, including letters, digits, an uppercase and a special character",
    invalidPassword_2: "Password requirement doesn't match",
    tryAgainLater: "Please try after sometime",
    signInInsted: "This email is already registered, would you like to sign in instead?",
    migratedCustomerMessage: "Create a new password to complete your account activation",
    migratedInvitedCustomerMessage: "Welcome back. Please create a new password and be sure to check your email to complete activation",
    passWordMatchError: "Passwords do not match, please try again",
    emailInUseError: "This email is already in use",
    updatedSuccess: 'Updated successfully',
    acct_sidebar_with_msg:'To view or update your Wish List, please sign in or create an account.',
    account_already_enabled:'You have already activated your account, would you like to sign in instead?',
    invalid_activation_link:'That activation link is invalid. Please retry the link in the email we sent to you.'
  },
  newsLetterSignup : {
    invalidEmail : 'This is not a valid email address',
    alreadyRegistered : 'This email is already registered',
    successSignup : 'You are successfully signed up to receive emails. Use WELCOME15 for 15% off',
    somethingWrong : 'Something Went wrong'
  },
  installmentMsg : {
    paymentMsg : 'Pay in full or choose a flexible payment plan with Shop Pay.',
  }
};